import "core-js";
import "whatwg-fetch";

import ready from "./core/ready";

import FixedHeader from "./components/fixed-header";
import StickyHeader from "./components/sticky-header";
import TouchMenu from "./components/touch-menu";
import GeckoSlideshow from "./components/gecko-slideshow";

import Konami from "./core/konami";

import LocationMap from "./components/location-map";

import "./weak";

ready(() => {
	let locator = new LocationMap();

	const menu = TouchMenu.searchAndLoadOne();

	FixedHeader.searchAndLoad()
		.forEach(header => {
			header.watch();

			const toggleEl = header.element.querySelector(`[data-action="toggle-touch-menu"]`);

			if (toggleEl) {
				toggleEl.addEventListener("click", () => {
					menu.toggle();
				});
			}
		});



	let stickyHeader = new StickyHeader(document.querySelector("header[data-sticky-header]"));
	let lastPosition = -1;
	function mainLoop() {
		if (lastPosition == window.pageYOffset) {
			requestAnimationFrame(mainLoop);
			return false;
		} else {
			lastPosition = window.pageYOffset;

			if(stickyHeader) {
				stickyHeader.checkSticky()
			}
		}
		requestAnimationFrame(mainLoop);
	}
	mainLoop();



	GeckoSlideshow.searchAndLoad()
		.forEach(slideshow => {
			slideshow.reify();
		});

	Konami.init();
	Konami.hook(() => {
		document.documentElement.classList.add("konami");
	});



	let headerSearchButton = document.querySelector(".header-search-trigger");
	let headerSearchForm = <HTMLFormElement> document.querySelector("form.header-search");
	if (headerSearchButton) {
		headerSearchButton.addEventListener("click", (e) => {
			e.preventDefault();

			if (headerSearchForm) {
				let headerSearchInput = <HTMLInputElement> headerSearchForm.querySelector("input");
				if (headerSearchForm.getAttribute("data-status") === "active") {
					headerSearchForm.removeAttribute("data-status");
					headerSearchButton.removeAttribute("data-status");
					headerSearchInput.blur();
				} else {
					headerSearchForm.setAttribute("data-status", "active");
					headerSearchButton.setAttribute("data-status", "active");
					headerSearchInput.focus();
				}
			}
		});
	}


});